import   React                             ,
       { useState                          ,
	     useEffect                         ,
	     useRef                            }  from 'react';

import   classNames                           from 'classnames';

import   styles                               from './MediaList.module.scss';


import   Field                                from '../../widget/inputs/Field';
import   Select                               from '../../widget/inputs/Select';
import   AnimatedWaitingIcon2                 from '../../widget/animations/animatedWaitingIcon2';
import   VideoPlayer                          from '../../widget/players/VideoPlayer';
import   Window                               from '../../widget/windows/window';
import   Box                                  from '../../widget/windows/Box';
import   Icon                                 from '../../widget/images/Icon';
import { getSoundFileUrl                    }  from '../../../backendServices/mediaManagment/api_sound';
import   ColumnTitle                          from '../../widget/dataDisplay/labels/ColumnTitle'
import   MediaRow                             from './MediaRow';
import   MediaSheet                           from './MediaSheet';
import   MediaCategoryManager                 from '../mediaCategoryManagment/MediaCategoryManager';

import { MediaCategory                     ,
         Media                             ,
         MediaDeletionPlan                 }  from '../../../dataTypes/mediaManagment/types';

import { updateMediaVisibility             ,
         deleteMedia                       ,
         getMediaDeletionPlan              ,
         getVerifiedMedia                   }  from '../../../backendServices/mediaManagment/api';
import { getMediaCategories                }  from '../../../backendServices/mediaManagment/api_category';
import { WWW_URLS                          }  from '../../../backendServices/urls';

import { retrieveMediaList                 }  from '../../../store/mediaManagment/actions';

import { useTypedSelector, useTypedDispatch }  from '../../../store/useTypeSelector';
import { refreshAdmin                       }  from '../../../store/adminAuthenticationManagment/actions';
import { RootState                         }  from '../../../store/generalReducer';
import { getUploadStatistics               , 
         hasActiveUploads                  , 
		 getUploadsByEntityType            }  from '../../../store/fileManagment/actions';

/**
 * Le contenu de la fenêtre de confirmation, tiré du plan renvoyé par le serveur.
 *
 * Les phrases viennent telles quelles du serveur : lui seul sait ce qui retient le
 * média, et une reformulation ici finirait par mentir le jour où la règle changera.
 *
 * Window rend son message à l'intérieur d'un <p> : seuls des éléments en ligne y sont
 * valides, d'où ces <span> passés en display:block plutôt qu'une vraie liste.
 */
const renderDeletionPlan = ( name : string | undefined ,
                             plan : MediaDeletionPlan    ): JSX.Element => {

  // Ne sert plus qu'à la fenêtre de REFUS : la confirmation, elle, tient en une
  // phrase. Le plan n'est donc jamais null ici, et le titre n'a plus qu'une forme.
  return (
    <>
      <span style = {{ display: 'block', fontWeight: 600, marginBottom: '0.75rem' }}>
        « {name ?? 'Ce média'} »
      </span>

      <span style = {{ display: 'block', marginBottom: '0.5rem' }}>
        {plan.summary}
      </span>

      {
        plan.details.map ( (detail, index) => (
          <span key   = {index}
                style = {{ display: 'block', marginTop: '0.35rem', opacity: 0.85 }}>
            — {detail}
          </span>
        ))
      }
    </>
  );
};

// « Ajouter une vidéo » du tableau de bord d'une chaîne : la section Médias n'est pas montée
// à ce moment-là, la demande est donc posée ici et lue au montage de la liste.
let pendingMediaCreation = false;
export const requestMediaCreation = () => { pendingMediaCreation = true; };

export const MediaList = () => {

  const mediaTypeNames = ['Tous', 'Vidéo', 'Image', 'Son', 'Diaporama audio'];

  const mediaTypeMapping: { [key: string]: string } = {
    'Tous'            : 'All',
    'Vidéo'           : 'Video',
    'Image'           : 'Image',
    'Son'             : 'Sound',
    'Diaporama audio' : 'AudioSlideshow',
  };

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  const dispatch           = useTypedDispatch();
  
  const [ categorySet            , setCategorySet            ] = useState<MediaCategory[]>([]);
  const [ mediaSet               , setMediaSet               ] = useState<Media[]>([]);
  const [ mediaSet2              , setMediaSet2              ] = useState<Media[]>([]);

  const [ showWaitingIcon        , setShowWaitingIcon        ] = useState(false);

  const [ selectedMediaType      , setSelectedMediaType      ] = useState('Tous');
  const [  , setSelectedMediaTypeIndex ] = useState(0);
  const [ selectedCategory       , setSelectedCategory       ] = useState('Toutes');
  const [ selectedCategoryIndex  , setSelectedCategoryIndex  ] = useState(0);
  const [ filter                 , setFilter                 ] = useState('');
  // Les filtres courants, lisibles depuis les rechargements (minuterie, retour d'édition) dont la fermeture est périmée.
  const filtresRef = useRef({ categoryIndex: 0, filter: '', mediaType: 'Tous' });
  filtresRef.current = { categoryIndex: selectedCategoryIndex, filter, mediaType: selectedMediaType };

  const [             , setEditMediaId            ] = useState<number | null>(null);
  const [ editMediaIndex         , setEditMediaIndex         ] = useState<number | null>(null);
  const [ createNewMedia         , setCreateNewMedia         ] = useState<boolean>(pendingMediaCreation);
  useEffect(() => { pendingMediaCreation = false; }, []);
  const [ showCategoryManager    , setShowCategoryManager    ] = useState<boolean>(false);

  const [ currentMediaUrl        , setCurrentMediaUrl        ] = useState<string | null>(null);
  const [ currentMedia           , setCurrentMedia           ] = useState<Media | null>(null);

  // Image affichée en grand, ou son à écouter (fenêtre de zoom), au clic sur sa vignette.
  const [ zoomedMedia            , setZoomedMedia            ] = useState<Media | null>(null);

  useEffect(() => {
    if ( !zoomedMedia ) return;
    const handleKeyDown = (e: KeyboardEvent) => { if ( e.key === 'Escape' ) setZoomedMedia(null); };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [zoomedMedia]);

  const [ showMessageWindow      , setShowMessageWindow      ] = useState              ( false );
  const [ message                , setMessage                ] = useState              ( <></> );

  const [ showConfirmation , setShowConfirmation ] = useState(false);
  const [ mediaToDelete    , setMediaToDelete    ] = useState<Media | null>(null);

  // Ce que la suppression fera, demandé au serveur avant d'ouvrir la confirmation :
  // derrière le même bouton se cachent trois conséquences très différentes.
  const [ deletionPlan     , setDeletionPlan     ] = useState<MediaDeletionPlan | null>(null);

  const [    , setUploadProgress   ] = useState(0);

 // Nouveaux états pour la gestion des uploads
  // Valeur inutilisée, mais l'abonnement est conservé : le retirer changerait
  // la fréquence de rendu du composant.
  useTypedSelector(getUploadStatistics);
  const hasUploads = useTypedSelector(hasActiveUploads);
  const videoUploads = useTypedSelector(state => getUploadsByEntityType(state, 'video'));
  
  // État pour forcer le rechargement périodique
  const [autoRefreshInterval, setAutoRefreshInterval] = useState<NodeJS.Timeout | null>(null);
 
 // Effet pour gérer le rechargement automatique quand il y a des uploads actifs
  useEffect(() => {
    if (hasUploads) {
      // Démarrer un timer de rechargement toutes les 30 secondes quand il y a des uploads
      if (!autoRefreshInterval) {
        const interval = setInterval(() => {
          console.log('Auto-refresh des médias (uploads en cours)');
          reloadMedias(true);
        }, 30000); // 30 secondes
        
        setAutoRefreshInterval(interval);
      }
    } else {
      // Arrêter le timer quand il n'y a plus d'uploads
      if (autoRefreshInterval) {
        clearInterval(autoRefreshInterval);
        setAutoRefreshInterval(null);
        
        // Un dernier refresh pour récupérer les vidéos finalisées
        console.log('Dernier refresh après fin des uploads');
        reloadMedias(true);
      }
    }
    
    return () => {
      if (autoRefreshInterval) {
        clearInterval(autoRefreshInterval);
      }
    };
  }, [hasUploads, autoRefreshInterval]);

  // Sortie programmée : la mise en ligne se fait côté serveur (cron chaque minute), et la liste
  // n'est qu'une photo. On la relit juste après l'échéance, puis toutes les 30 s tant que la
  // vidéo n'est pas active (son transcodage peut finir après la date). Pas pendant une fiche
  // ouverte : celle-ci désigne son média par son rang dans la liste.
  useEffect(() => {
    if (createNewMedia || editMediaIndex !== null) return;
    const echeances = mediaSet2
      .filter(media => media.activeScheduled && !media.active && media.activeStartDate)
      .map(media => new Date(media.activeStartDate as Date).getTime());
    if (echeances.length === 0) return;
    const delai = Math.max(30000, Math.min(...echeances) + 65000 - Date.now());
    const timer = setTimeout(() => reloadMedias(true), Math.min(delai, 3600000));
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaSet2, createNewMedia, editMediaIndex]);

  // Effet pour surveiller les changements d'uploads et afficher les infos
  useEffect(() => {
    if (videoUploads.length > 0) {
      console.log(`${videoUploads.length} uploads vidéo en cours:`, 
        videoUploads.map(u => ({ 
          entityId: u.entityId, 
          progress: u.progress, 
          status: u.status 
        }))
      );
    }
  }, [videoUploads]);
  
  
  
  
  useEffect(() => {

    const fetchData = async () => {

      try
       {
        setShowWaitingIcon(true);

        const [mediasResult, categoriesResult] = await Promise.all([
          retrieveMediaList ( {}, [],  true, authentication.admin?.id ),
          getMediaCategories(),
        ]);
		
		console.log (mediasResult)

		  const sortedMediaSet = [...mediasResult].sort((a, b) => b.id - a.id);
			 
          setMediaSet(sortedMediaSet);
          setMediaSet2(sortedMediaSet);
          // La taille d'une vidéo n'est mesurée (et reportée sur quotaUsed) qu'à la fin de
          // son transcodage, côté serveur : on relit le compte pour que l'en-tête suive.
          if (authentication.admin?.email) { dispatch(refreshAdmin(authentication.admin.email)); }

        if (categoriesResult.payload)
         {
          setCategorySet(categoriesResult.payload.sort((a, b) => a.rank - b.rank));
         }
       }
      catch (error)
       {
        console.error('Error fetching data:', error);
       }
      finally
       {
        setShowWaitingIcon(false);
       }
    };

    fetchData();
  }, []);

  // `silencieux` : rechargement de fond (fin d'un transcodage, rafraîchissement
  // périodique). Sans voile ni logo tournant, sinon l'écran clignote à chaque fois ;
  // la liste se met simplement à jour.
  const reloadMedias = async (silencieux: boolean = false) => {

      try
       {
        if (!silencieux) setShowWaitingIcon(true);

        const mediasResult = await retrieveMediaList ( {}, [], true, authentication.admin?.id ) // getMediaList ()

		console.log ("reloadMedias", mediasResult)

        const sortedMediaSet = [...mediasResult].sort((a, b) => b.id - a.id);
        const { categoryIndex, filter: filterText, mediaType } = filtresRef.current;
			 
        setMediaSet2(sortedMediaSet);
        // Les filtres restent affichés : la liste doit continuer à en tenir compte.
        setMediaSet(filterMedias(categoryIndex, filterText, mediaType, sortedMediaSet));
        if (authentication.admin?.email) { dispatch(refreshAdmin(authentication.admin.email)); }
       }
      catch (error)
       {
        console.error('Error fetching data:', error);
       }
      finally
       {
        if (!silencieux) setShowWaitingIcon(false);
       }
  }

  const checkFilter = (subChaine: string, chaine: string) => {
    if (subChaine === '') return true;
    return chaine.toUpperCase().includes(subChaine.toUpperCase());
  };

  const filterMedias = (categoryIndex: number, filterText: string, mediaType: string, source: Media[] = mediaSet2): Media[] => {

    console.log ('filterMedias', categoryIndex)

    const filteredMediaSet = source.filter((media) => {

      const matchesCategory  = categoryIndex <= 1 || media.categoriesIds.includes(categorySet[categoryIndex - 2]?.id);
      const matchesFilter    = checkFilter(filterText, media.name);
      const matchesMediaType = mediaType === 'Tous' || media.mediaType === mediaTypeMapping[mediaType];

      return matchesCategory && matchesFilter && matchesMediaType;
    });
	
	const sortedMediaSet = [...filteredMediaSet].sort((a, b) => b.id - a.id);

    return sortedMediaSet
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newCategoryIndex = e.target.selectedIndex;

    setSelectedCategory(e.target.value);
    setSelectedCategoryIndex(newCategoryIndex);
    setMediaSet(filterMedias(newCategoryIndex, filter, selectedMediaType));
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFilter = e.target.value;
    setFilter(newFilter);
    setMediaSet(filterMedias(selectedCategoryIndex, newFilter, selectedMediaType));
  };

  const handleMediaTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMediaType = e.target.value;
    setSelectedMediaType(newMediaType);
    setSelectedMediaTypeIndex(e.target.selectedIndex);
    setMediaSet(filterMedias(selectedCategoryIndex, filter, newMediaType));
  };

  const handleEditionClick = (index: number) => {
    setEditMediaId(mediaSet[index].id);
    setEditMediaIndex(index);
  };


  const handleMediaView = (index: number, withQRcode: boolean = false) => {

    // Une image ou un son n'a pas de flux HLS : on l'ouvre dans la fenêtre de zoom.
    if ( mediaSet[index].mediaType === 'Image' || mediaSet[index].mediaType === 'Sound' )
     {
      setZoomedMedia(mediaSet[index]);
      return;
     }

    /*
    const urlMedia = `${WWW_URLS.MediaServer}${mediaSet[index].publicRef}/videos/001/index.m3u8`

    setCurrentMediaUrl(urlMedia);
    setCurrentMedia(mediaSet[index]);*/

   const tab = withQRcode 
               ? [
                   `${WWW_URLS.MediaServer}${mediaSet[index].publicRef}/videos/002/index.m3u8`,
                   `${WWW_URLS.MediaServer}${mediaSet[index].publicRef}/videos/001/index.m3u8`,
                 ]
               : [
                   `${WWW_URLS.MediaServer}${mediaSet[index].publicRef}/videos/001/index.m3u8`,
                 ]
				

  getVerifiedMedia(tab).then((url) => {
    if (url) {
      setCurrentMediaUrl(url);
      setCurrentMedia(mediaSet[index]);
    }
  });


  };

  const handleDeleteClick = async (media: Media) => {

    setMediaToDelete(media);

    // On demande d'abord au serveur ce que la suppression fera. Sans cette réponse on
    // poserait la même question dans les trois cas — alors que l'un efface tout, un
    // autre n'efface que les fichiers, et le troisième ne peut rien faire.
    const response = await getMediaDeletionPlan(media);

    // Si le plan n'a pas pu être obtenu, on ne bloque pas l'utilisateur : on pose la
    // question sans le détail, et c'est le serveur qui tranchera à la confirmation.
    setDeletionPlan(response.code === 1 ? response.payload : null);

    setShowConfirmation(true);
  };

  const handleDeleteConfirmation = async (confirmed: boolean)=> {

    console.log('[handleDeleteConfirmation] appel', { confirmed, mediaToDelete });

    if ( confirmed && mediaToDelete )
     {
      try
       {
        const response = await deleteMedia ( mediaToDelete            ,
                                             authentication.admin?.id );

        console.log('[handleDeleteConfirmation] réponse deleteMedia', response);

        if (response.code === 1)
              {
               setMediaSet((prev) => prev.filter((media) => media.id !== mediaToDelete.id));
               setMediaSet2((prev) => prev.filter((media) => media.id !== mediaToDelete.id));
               console.log(`Media avec ID ${mediaToDelete.id} supprimé.`);
               // La suppression rend sa place au quota côté serveur : on recharge le compte
               // pour que l'en-tête et les sélecteurs d'espace ne gardent pas l'ancien quotaUsed.
               if (authentication.admin?.email) { dispatch(refreshAdmin(authentication.admin.email)); }
               setMessage(<></>);
               setShowMessageWindow(false);
              }
         else if (response.code === -104)
              {
               // Le média n'existe déjà plus côté serveur (ex. ligne obsolète après une
               // précédente suppression) : on répare la liste au lieu d'afficher une erreur.
               setMediaSet((prev) => prev.filter((media) => media.id !== mediaToDelete.id));
               setMediaSet2((prev) => prev.filter((media) => media.id !== mediaToDelete.id));
               console.log(`Media avec ID ${mediaToDelete.id} déjà supprimé côté serveur, liste corrigée.`);
               setMessage(<>Ce média avait déjà été supprimé, la liste a été mise à jour</>);
               setShowMessageWindow(true);
              }
         else {
               console.warn(`Impossible de supprimer la vidéo ID ${mediaToDelete.id} : ${response.comment}`);
               setMessage (
                           // Sur un refus (-103), le commentaire est la phrase rédigée par le
                           // serveur : elle nomme la chaîne et l'horaire quand le média est au
                           // programme, et retombe sur une formulation générique sinon.
                           response.code === -103
                           ? <>{response.comment}</>
                           : <>Impossible de supprimer le média</>
                          );
               setShowMessageWindow(true);
              }
       }
      catch (error)
       {
        console.error(`Erreur lors de la suppression du média ID ${mediaToDelete.id}:`, error);
        setMessage(<>Impossible de supprimer le média</>);
        setShowMessageWindow(true);
       }
     }

    setShowConfirmation(false);
    setMediaToDelete(null);
    setDeletionPlan(null);
  };

  const handleVisibilityChange = (mediaId: number) => {

    setMediaSet((prevMediaSet) => {

      const updatedMediaSet = prevMediaSet.map((media) => {

        if (media.id === mediaId && (media.state === 0 || media.state === 1))
         {
          const newState = media.state === 0 ? 1 : 0; // Inverser l'état
          updateMediaVisibility(media, newState); // Appeler l'API
          return { ...media, state: newState }; // Retourner le média mis à jour
         }

        return media;
       });

    // mediaSet2 est la liste complète : on n'y reporte que les médias dont l'état a changé,
    // sans l'écraser par la liste filtrée.
    setMediaSet2((prev) => prev.map((m) => updatedMediaSet.find((u) => u.id === m.id) ?? m));

    return updatedMediaSet;
   });
  };

  const handleTranscoded = (mediaId: number) => {
    reloadMedias(true)
  }

  const handleNewMediaCreationClick = () => {
    setCreateNewMedia (true)
  };

  const handleCategoryManagerOpen = () => {
    setShowCategoryManager (true)
  };

  // Retour à la liste des médias : les rubriques ont pu être créées / supprimées / réordonnées,
  // et le filtre catégorie est indexé sur la position dans categorySet — on le remet à zéro.
  const handleCategoryManagerClose = async () => {

    setShowCategoryManager   (false);
    setSelectedCategory      ('Toutes');
    setSelectedCategoryIndex (0);
    setMediaSet              (filterMedias(0, filter, selectedMediaType));

    try
     {
      const categoriesResult = await getMediaCategories();

      if (categoriesResult.payload)
       {
        setCategorySet(categoriesResult.payload.sort((a, b) => a.rank - b.rank));
       }
     }
    catch (error)
     {
      console.error('Error fetching categories:', error);
     }
  };


  const renderMediaTypeSelection = (): JSX.Element => {

    return (
      <Select choices  = {mediaTypeNames}
              value    = {selectedMediaType}
              onChange = {handleMediaTypeChange} />
    );
  };

  const renderCategoriesSelection = (): JSX.Element => {
    const categoriesNames = ['Toutes', ...categorySet.map((c) => c.name)];
    return (
      <Select choices  = {categoriesNames}
              value    = {selectedCategory}
              onChange = {handleCategoryChange} />
    );
  };

  const handleMediaCreate = (id: number) => {
    setCreateNewMedia(false);
    
    console.log(`Nouvelle vidéo créée avec ID: ${id}, rechargement de la liste`);
    reloadMedias();
  };

  const handleMediaEdit = (id: number) => {
    setEditMediaId(null);
    setEditMediaIndex(null);
    
    console.log(`Vidéo ${id} modifiée, rechargement de la liste`);
    reloadMedias();
  };

  const renderComponent = () : JSX.Element => {

    if ( showCategoryManager )
     {
      return <MediaCategoryManager nested onBackToMedia={handleCategoryManagerClose} />
     }

    if ( currentMediaUrl )
          {
           if ( currentMedia )
                 {
                       if ( currentMedia.mediaType === 'Video' )
                        {
                        // return <VideoPlayerWithAdvertisingSupport video={currentMedia as Video} enableAdvertisements={false}/>
                         return <VideoPlayer url={currentMediaUrl} />
                        }
                  else if ( currentMedia.mediaType === 'AudioSlideshow' )
                        {
                         return <VideoPlayer url={currentMediaUrl} />
                        }
                  else  {
                         return <></>
                        }
                 }
                  else  {
                         return <></>
                        }
          }
     else {
           if ( createNewMedia )
                 {
                  return <MediaSheet onCreate               = {handleMediaCreate} 
				                     uploadProgressFunction = {setUploadProgress} />
                 }
            else {
                  if ( editMediaIndex !== null )
                        {
                          return <MediaSheet media                  = {mediaSet[editMediaIndex]} 
						                     onEdit                 = {handleMediaEdit}  
				                             uploadProgressFunction = {setUploadProgress} />
                        }
                   else {
                         return (
                                  <>

                                    <div className={classNames(styles.page_header)}>
                                      <div className={classNames(styles.page_header_text)}>
                                        <h1 className={classNames(styles.page_title)}>Vidéo</h1>
                                        <p className={classNames(styles.page_subtitle)}>Gérez, organisez et diffusez vos vidéos et contenus multimédias.</p>
                                      </div>
                                      <div className={classNames(styles.mediaCreationButton)}>
                                        <button className={classNames(styles.btn, styles.btnPrimary)}
                                                onClick={handleNewMediaCreationClick}>
                                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                          </svg>
                                          Ajouter vidéo
                                        </button>
                                      </div>
                                    </div>

                                    <div className={classNames(styles.upper_bar)}>
                                        {renderMediaTypeSelection()}
                                        {renderCategoriesSelection()}
                                        <Field type        = "text"
                                               placeholder = "Rechercher..."
                                               value       = {filter}
                                               onChange    = {handleFilterChange} />
                                    </div>

                                    {
                                     zoomedMedia &&
                                     <Box onClose       = {() => setZoomedMedia(null)}
                                          width         = "max-content"
                                          marginTop     = "0px"
                                          contentMargin = "0px">
                                       {
                                        zoomedMedia.mediaType === 'Sound'
                                        ?
                                        <div className={classNames(styles.zoom_content, styles.zoom_content_sound)}>
                                          {/* Un son n'a pas d'image : la même icône que sa ligne, en grand. */}
                                          <Icon name="musicalNotes" width={240} height={240} color="var(--color-0)" hoverable={false} clickable={false} />
                                          {/* Le rendu AAC public n'existe que pour les sons transcodés depuis le 21/10 :
                                              les plus anciens sont lus depuis leur source, par l'API. */}
                                          <audio className={classNames(styles.zoom_audio)}
                                                 src={zoomedMedia.publicRef ? `${WWW_URLS.MediaServer}${zoomedMedia.publicRef}/sounds/audio.aac` : getSoundFileUrl(zoomedMedia.id)}
                                                 controls
                                                 onError={(e) => {
                                                                   const audio = e.currentTarget;
                                                                   const repli = getSoundFileUrl(zoomedMedia.id);
                                                                   if ( audio.src !== repli ) audio.src = repli;
                                                                 }} />
                                        </div>
                                        :
                                        <div className={classNames(styles.zoom_content)}>
                                          {/* Le rendu pleine résolution n'existe que pour les images créées ou rattrapées
                                              depuis le 22/10 : on retombe sur la grande vignette, puis la petite. */}
                                          <img className={classNames(styles.zoom_image)}
                                               src={`${WWW_URLS.MediaServer}${zoomedMedia.publicRef}/images/image.webp`}
                                               alt={zoomedMedia.name}
                                               onError={(e) => {
                                                                 const img = e.currentTarget;
                                                                 if      ( img.src.endsWith('/image.webp')         ) img.src = `${WWW_URLS.MediaServer}${zoomedMedia.publicRef}/images/thumbnail_BIG.webp`;
                                                                 else if ( img.src.endsWith('/thumbnail_BIG.webp') ) img.src = `${WWW_URLS.MediaServer}${zoomedMedia.publicRef}/images/thumbnail.webp`;
                                                               }} />
                                        </div>
                                       }
                                     </Box>
                                    }

                                    <div className={classNames(styles.list_container)}>

                                      <div className={classNames(styles.list)}>

                                        <ColumnTitle titles = {[ 'Index' , 'Type' , 'Vignette' , 'Titre' , 'Durée' , 'Taille' , 'Vues' , 'URL'   , 'Actions' , 'Actif' , 'Payant' , 'Public' , 'Multi-angle' ]}
                                                     widths = {[ '50px'  , '50px' , '150px'    , 'auto'  , '80px'  , '90px'   , '90px' , '380px' , '160px'    , '80px'  , '80px'   , '80px'   , '110px'       ]} />
                                        {
                                         mediaSet.map ( (media, index) => (
                                                                            <MediaRow key                = {media.id}
                                                                                      media              = {media}
                                                                                      index              = {index}
                                                                                      onEdit             = {handleEditionClick}
                                                                                      onDelete           = {handleDeleteClick}
                                                                                      onVisibilityToggle = {handleVisibilityChange}
                                                                                      onView             = {handleMediaView}
                                                                                      onTranscoded       = {handleTranscoded}/>
                                                                          )
                                                      )
                                        }
                                      </div>

                                    </div>

                                  </>
                                )
                        }
                 }
          }
  }


  const handleMessageWindowClose = () => {

    setShowMessageWindow (false)
  }

  return (
    <div className={classNames(styles.root)}>
	
              { 
               showWaitingIcon && 
               <>
                 <div className={classNames(styles.overlay)} />
                 <AnimatedWaitingIcon2 />
               </>
              }
	
      {
        showMessageWindow &&
        <Window message                 = {message}
                messageType             = "information"
                onClickOnValidateButton = {handleMessageWindowClose} 
				validButtonText="Ok"    />
      }

      {
        // Suppression impossible : on le dit, on nomme ce qui retient le média, et on
        // n'offre pas de bouton qui ne mènerait nulle part.
        showConfirmation && deletionPlan !== null && ! deletionPlan.canDelete &&
        <Window
          message                 = {renderDeletionPlan(mediaToDelete?.name, deletionPlan)}
          messageType             = "information"
          messageImportance       = "important"
          width                   = "34rem"
          onClickOnValidateButton = {() => handleDeleteConfirmation(false)}
          validButtonText         = "Fermer" />
      }

      {
        // La question posée est courte et sans détour. Le plan complet — ce qui part,
        // ce qui reste — n'est déroulé que dans la fenêtre de REFUS ci-dessus, où il
        // est la seule chose utile à lire. Ici, l'utilisateur a demandé une
        // suppression : il attend une confirmation, pas un rapport.
        showConfirmation && (deletionPlan === null || deletionPlan.canDelete) &&
        <Window
          message                 = {(deletionPlan?.angleCount ?? 0) > 0 || (deletionPlan === null && mediaToDelete?.multiview)
                                       ? <>Cette vidéo multiview et {deletionPlan ? `ses ${deletionPlan.angleCount} angle(s)` : 'ses angles'} vont être supprimés. Les enregistrements d'origine restent dans le Stockage. Continuer ?</>
                                       : <>Votre média va être supprimé</>}
          messageType             = "question"
          messageImportance       = {deletionPlan?.outcome === 'complete' ? 'important' : 'normal'}
          width                   = "34rem"
          onClickOnValidateButton = {() => handleDeleteConfirmation(true)}
          onClickOnCancelButton   = {() => handleDeleteConfirmation(false)}
		  validButtonText="Oui"
		  cancelButtonText="Non" />
      }

      {renderComponent ()}
    </div>
  );
};

export default MediaList;